import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=1bdb08da&scoped=true"
import script from "./Organization.vue?vue&type=script&lang=js"
export * from "./Organization.vue?vue&type=script&lang=js"
import style0 from "./Organization.vue?vue&type=style&index=0&id=1bdb08da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdb08da",
  null
  
)

export default component.exports